
import { URL_CREATELEAD, URL_CREATECAMPAIGNLEAD, URL_UPDATELEAD } from '../api/api.js';

/**
 * 提供全局方法
 */
window.Util = window.Util || {}
/**
 * 
 * @param {*} filterArr 需要重置表单在字段数组
 * @param {*} fields 整个表单
 * @param {*} formData 整个表单数据
 */
function resetField(filterArr, fields, formData) {
  let obj = {}
  for (let i = 0; i < filterArr.length; i++) {
    obj = _.find(fields, {
      prop: filterArr[i]
    })
    if (!!obj)
    formData[obj.prop]=null
      // obj.resetField()
  }
}

// /**
//  * 更新salesforce 步骤
//  * @param obj
//  * @param step
//  */
// function editSalesforce(obj,step){
//   if (obj.id){
//     URL_CREATELEAD({Application_Page__c:step,Id:obj.id}).then(res=>{});
//   }
//   if (obj.sf_campaignlead_id){
//       URL_CREATECAMPAIGNLEAD({Application_Page__c:step,sf_campaignlead_id:obj.sf_campaignlead_id}).then(res=>{});
//   }
//   return ;
// }
/**
 * 更新salesforce 步骤
 * @param obj
 * @param step
 */
function editSalesforce(obj, step) {
  if (obj.middle_lead_id) {
    URL_UPDATELEAD({ Application_Page__c: step, middle_lead_id: obj.middle_lead_id }).then(res => { });
  }
  return ;
}


window.Util = {
  resetField: resetField,
  editSalesforce:editSalesforce
}
export default window.Util



// WEBPACK FOOTER //
// ./src/util/index.js